import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import OriginIcon from '@material-ui/icons/TripOrigin';

const useStyles = makeStyles(() => ({
  root: {
    padding: '5px'
  }
}));

const RadioButton = ({ title, value, ...rest }) => {
  const classes = useStyles({ value });

  return (
    <Box
      component={FormControlLabel}
      label={title}
      value={value}
      bgcolor="#FFF"
      control={
        <Radio classes={{ root: classes.root }} checkedIcon={<OriginIcon color="primary" />} />
      }
      className={classes.checkboxStyle}
      {...rest}
    />
  );
};

RadioButton.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

export default RadioButton;
